"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactsLimitsDependenciesSelector = exports.emailSendMultiplierSelector = exports.minPurchasableContactsSelector = exports.purchasedContactsQuantitySelector = exports.purchasedMarketingContactsQuantitySelector = exports.purchasedContactsUnitsSelector = exports.contactsQuantityMultiplierSelector = exports.numContactsInCrmSelector = void 0;

var _reselect = require("reselect");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _ParcelGroups = require("pricing-pages-unified-ui/constants/ParcelGroups");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var _ParcelQuantityMap = require("self-service-api/constants/ParcelQuantityMap");

var numContactsInCrmSelector = function numContactsInCrmSelector(_ref) {
  var numContactsInCrm = _ref.numContactsInCrm;
  return numContactsInCrm;
}; // Returns the contacts quantity multiplier for the additionalUnitMerchId of the activeMerchId


exports.numContactsInCrmSelector = numContactsInCrmSelector;
var contactsQuantityMultiplierSelector = (0, _reselect.createSelector)([_MerchandiseSelectors.merchandiseSelector, function (_, merchandiseId) {
  return merchandiseId;
}], function (merchandise, merchandiseId) {
  if (!merchandise || !merchandiseId) return null;
  var additionalUnitMerchId = merchandise[merchandiseId].additionalUnitMerchId;

  if (!additionalUnitMerchId) {
    if ('quantityMultiplier' in merchandise[merchandiseId]) {
      return merchandise[merchandiseId].quantityMultiplier;
    }

    return null;
  }

  return merchandise[additionalUnitMerchId].quantityMultiplier;
}); // returns amount of contacts units a user has purchased

exports.contactsQuantityMultiplierSelector = contactsQuantityMultiplierSelector;
var purchasedContactsUnitsSelector = (0, _reselect.createSelector)(_ProductOwnershipSelectors.parcelsSelector, function (parcels) {
  var contactsParcel = parcels.find(function (_ref2) {
    var parcelName = _ref2.parcelName;
    return _ParcelGroups.ADDITIONAL_CONTACTS.includes(parcelName);
  });
  var hasNoPurchasedContacts = !contactsParcel;
  if (hasNoPurchasedContacts) return 0;
  return contactsParcel.quantity;
});
exports.purchasedContactsUnitsSelector = purchasedContactsUnitsSelector;

var purchasedMarketingContactsQuantitySelector = function purchasedMarketingContactsQuantitySelector(state) {
  var parcels = (0, _ProductOwnershipSelectors.parcelsSelector)(state);
  var sum = 0;
  Object.keys(_ParcelQuantityMap.MARKETING_CONTACTS_QUANTITIES).forEach(function (parcelName) {
    var foundParcel = parcels.find(function (_ref3) {
      var search = _ref3.parcelName;
      return search === parcelName;
    });

    if (foundParcel) {
      sum += _ParcelQuantityMap.MARKETING_CONTACTS_QUANTITIES[parcelName] * foundParcel.quantity;
    }
  });
  return sum;
}; // returns amount of contacts a user has purchased


exports.purchasedMarketingContactsQuantitySelector = purchasedMarketingContactsQuantitySelector;
var purchasedContactsQuantitySelector = (0, _reselect.createSelector)([purchasedContactsUnitsSelector, contactsQuantityMultiplierSelector], function (purchasedContactsUnits, contactsQuantityMultiplier) {
  return purchasedContactsUnits * contactsQuantityMultiplier;
}); // returns minimum amount of contacts a user can buy

exports.purchasedContactsQuantitySelector = purchasedContactsQuantitySelector;
var minPurchasableContactsSelector = (0, _reselect.createSelector)([_MerchandiseSelectors.merchandiseSelector, function (_, merchandiseId) {
  return merchandiseId;
}, numContactsInCrmSelector, _MarketingContactsSelectors.marketingContactsOnRenewalSelector, contactsQuantityMultiplierSelector, purchasedContactsQuantitySelector, purchasedMarketingContactsQuantitySelector, _MarketingContactsSelectors.isMarketingContactsSKUSelector], function (merchandise, merchandiseId, numContactsInCrm, marketingContactsOnRenewal, contactsQuantityMultiplier, purchasedContactsQuantity, purchasedMarketingContactsQuantity, isMarketingContactsSKU) {
  // missing information in state
  if (numContactsInCrm === null || isMarketingContactsSKU && marketingContactsOnRenewal === null || !contactsQuantityMultiplier || !merchandiseId) {
    return null;
  }

  var includedAdditionalUnits = merchandise[merchandiseId].includedAdditionalUnits;

  if (isMarketingContactsSKU) {
    var billableAdditionalContacts = Math.max(0, marketingContactsOnRenewal - includedAdditionalUnits);
    return Math.ceil(Math.max(billableAdditionalContacts, purchasedMarketingContactsQuantity) / contactsQuantityMultiplier) * contactsQuantityMultiplier;
  } else {
    // hasn't bought contacts before
    if (!purchasedContactsQuantity) {
      // contacts in crm is fewer than minimum contacts purchase quantity
      if (numContactsInCrm < includedAdditionalUnits) {
        return includedAdditionalUnits;
      } // contacts in crm is fewer than quantity multiplier


      if (numContactsInCrm <= contactsQuantityMultiplier) {
        return contactsQuantityMultiplier;
      }
    }

    var purchasableContactsFromCrm = Math.ceil(numContactsInCrm / contactsQuantityMultiplier) * contactsQuantityMultiplier;
    return Math.max(purchasableContactsFromCrm, purchasedContactsQuantity);
  }
});
exports.minPurchasableContactsSelector = minPurchasableContactsSelector;

var emailSendMultiplierSelector = function emailSendMultiplierSelector(state, merchandiseId) {
  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);

  if (!merchandise || !merchandiseId) {
    return null;
  }

  var limits = merchandise[merchandiseId].limits;
  var emailSendLimitObject = limits.filter(function (limit) {
    return limit.name === 'email_sends';
  });

  if (emailSendLimitObject.length === 0) {
    return null;
  }

  var emailSendLimit = emailSendLimitObject[0].limit;
  var quantityMultiplier = contactsQuantityMultiplierSelector(state, merchandiseId);
  return emailSendLimit / quantityMultiplier;
};

exports.emailSendMultiplierSelector = emailSendMultiplierSelector;
var contactsLimitsDependenciesSelector = (0, _reselect.createSelector)(numContactsInCrmSelector, purchasedContactsUnitsSelector, function (numContactsInCrm, purchasedContactsUnits) {
  return {
    numContactsInCrm: numContactsInCrm,
    purchasedContactsUnits: purchasedContactsUnits
  };
});
exports.contactsLimitsDependenciesSelector = contactsLimitsDependenciesSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ContactsSelectors.js
// module id = 87
// module chunks = 5 6 7